import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import Header from "../../components/common/Header/Header";
import { fetchPromos } from "../../redux/actions/promos.actions";
import PromosContainer from "./components/PromosContainer";
import CreatePromoModal from "./components/CreatePromoModal";
import UpdatePromoModal from "./components/UpdatePromoModal";
import DeletePromoModal from "./components/DeletePromoModal";
import PromoDetailsModal from "./components/PromoDetailsModal";
import PromoPreviewModal from "./components/PromoPreviewModal";

const PromosPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];

  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [promoToModify, setPromoToModify] = useState<any>(null);

  useEffect(() => {
    dispatch(fetchPromos(searchParams.toString()));
  }, [dispatch, searchParams]);

  return (
    <div className="page lp-page">
      <CreatePromoModal open={createOpen} setOpen={setCreateOpen} />
      <UpdatePromoModal open={editOpen} setOpen={setEditOpen} object={promoToModify} />
      <DeletePromoModal open={deleteOpen} setOpen={setDeleteOpen} object={promoToModify} />
      <PromoDetailsModal open={viewOpen} setOpen={setViewOpen} object={promoToModify} />
      <PromoPreviewModal
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        promo={promoToModify}
      />

      <Header header="Promos" />
      <main className="lp-main">
        <PromosContainer
          setCreateOpen={setCreateOpen}
          setEditOpen={setEditOpen}
          setDeleteOpen={setDeleteOpen}
          setViewOpen={setViewOpen}
          setPreviewOpen={setPreviewOpen}
          setPromoToModify={setPromoToModify}
        />
      </main>
    </div>
  );
};

export default PromosPage;
